import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { searchParamSet } from '../../../../actions/SearchSolutionActions';
import { ACCEPTANCE_CANDIDATES, REGION_CANDIDATES, } from '../../../../define/consts/solution';
import { propArrayShape, propFunc, propShape, } from '../../../../helpers/custom-prop-types';
const makeList = (params, master) => {
    const { solutionLargeClass, solutionMiddleClass, solutionTag } = master;
    const result = [];
    // カテゴリ
    solutionLargeClass.forEach((large) => {
        if (!params[`large_${large.id}`]) {
            return;
        }
        result.push({
            id: `large_${large.id}`,
            name: large.name,
            value: [`large_${large.id}`],
        });
    });
    // 中カテゴリ
    solutionMiddleClass.forEach((middle) => {
        if (!params[`middle_${middle.id}`]) {
            return;
        }
        result.push({
            id: `middle_${middle.id}`,
            name: middle.name,
            value: [`middle_${middle.id}`],
        });
    });
    // 予算
    const { price_gte: priceGte, price_lte: priceLte } = params;
    if (priceGte &&
        priceLte &&
        parseInt(priceGte, 10) > 0 &&
        parseInt(priceLte, 10) > 0) {
        result.push({
            id: 'price_gte',
            name: `${priceGte}-${priceLte}万円`,
            value: ['price_gte', 'price_lte'],
        });
    }
    else if (priceGte && parseInt(priceGte, 10) > 0) {
        result.push({
            id: 'price_gte',
            name: `${priceGte}万円-`,
            value: ['price_gte'],
        });
    }
    else if (priceLte && parseInt(priceLte, 10) > 0) {
        result.push({
            id: 'price_lte',
            name: `-${priceLte}万円`,
            value: ['price_lte'],
        });
    }
    // 対応地域
    REGION_CANDIDATES.forEach(({ label, value }) => {
        if (!params[`region_${value}`]) {
            return;
        }
        result.push({
            id: `region_${value}`,
            name: label,
            value: [`region_${value}`],
        });
    });
    // 対応可能時期
    ACCEPTANCE_CANDIDATES.forEach(({ label, value }) => {
        if (!params[`acceptance_${value}`]) {
            return;
        }
        result.push({
            id: `acceptance_${value}`,
            name: label,
            value: [`acceptance_${value}`],
        });
    });
    // タグ
    solutionTag.forEach((tag) => {
        if (!params[`tag_${tag.id}`]) {
            return;
        }
        result.push({
            id: `tag_${tag.id}`,
            name: tag.name,
            value: [`tag_${tag.id}`],
        });
    });
    return result;
};
const SideMenuFilter = (props) => {
    const { params, setParam, solutionLargeClass, solutionMiddleClass, solutionTag, } = props;
    const currentFilters = makeList(params, {
        solutionLargeClass,
        solutionMiddleClass,
        solutionTag,
    });
    if (currentFilters.length === 0) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: 'search-refine' }, { children: [_jsx("h4", { children: "\u7D5E\u308A\u8FBC\u307F\u691C\u7D22" }), _jsx("div", Object.assign({ className: 'search-refine-list' }, { children: _jsx("ul", { children: currentFilters.map(({ id, name, value }) => (_jsxs("li", Object.assign({ onClick: () => setParam(value), role: 'presentation' }, { children: [name, _jsx("i", Object.assign({ className: 'material-icons md-14' }, { children: "clear" }))] }), id))) }) }))] })));
};
SideMenuFilter.propTypes = {
    params: propShape().isRequired,
    setParam: propFunc().isRequired,
    solutionLargeClass: propArrayShape().isRequired,
    solutionMiddleClass: propArrayShape().isRequired,
    solutionTag: propArrayShape().isRequired,
};
const mapStateToProps = ({ category, searchSolution }) => ({
    params: searchSolution.params,
    solutionLargeClass: category.solutionLargeClass || [],
    solutionMiddleClass: category.solutionMiddleClass || [],
    solutionTag: category.solutionTag || [],
});
const mapDispatchToProps = (dispatch) => ({
    setParam: (values) => {
        values.forEach((v) => dispatch(searchParamSet({
            [v]: false,
        })));
    },
});
const enhance = compose(connect(mapStateToProps, mapDispatchToProps));
export default enhance(SideMenuFilter);
